import { LuLoaderCircle } from 'react-icons/lu';
interface Props {
  content: string;
}
const ToastLoadingContent = (p: Props) => {
  return <div className='flex items-center gap-2' data-sentry-component="ToastLoadingContent" data-sentry-source-file="ToastLoadingContent.tsx">
      <LuLoaderCircle className='animate-spin' data-sentry-element="LuLoaderCircle" data-sentry-source-file="ToastLoadingContent.tsx" />
      {p.content}
    </div>;
};
export default ToastLoadingContent;